import Toolbar from './Components/Toolbar/toolbar.component';
import Description from './Components/Description/description.component';
import Grid from './Components/Grid/grid.component';

const App = () => {
  return (
    <div>
      <Toolbar />
      <Description />
      <Grid />
    </div>
  );
};

export default App;
